export const COMMISSION_GROUPS = [
  { key: 'general_managers', label: 'GENERAL_MANAGERS' },
  { key: 'managers', label: 'MANAGERS' },
  { key: 'seller_brokers', label: 'SELLER_BROKERS' },
  { key: 'optionist_brokers', label: 'OPTIONIST_BROKERS' },
];

export const PAYMENT_METHODS = [
  'especie',
  'deposito',
  'ted_doc',
  'pix',
  'cheque',
];

export const PAYMENT_TRIGGERS = [
  'assinatura_recibo_sinal',
  'retirada_certidoes',
  'ato_escritura',
  'transferencia_registros',
];

export const distributedCents = (totalCents, count) => {
  const size = Math.max(1, Number(count) || 1);
  const total = Math.max(0, Number(totalCents) || 0);
  const base = Math.floor(total / size);
  return Array.from({ length: size }, (_, index) =>
    index === size - 1 ? total - base * (size - 1) : base
  );
};

export const moneyCents = value => {
  const source = String(value || '').replace(/[R$\s]/g, '');
  const normalized = source.includes(',')
    ? source.replace(/\./g, '').replace(',', '.')
    : source;
  const number = Number(normalized);
  return Number.isFinite(number) ? Math.round(number * 100) : 0;
};

export const moneyInput = cents => (Number(cents || 0) / 100).toFixed(2);

export const emptyParticipant = () => ({
  user_id: '',
  name: '',
  percentage: '',
  amount: '0.00',
  person_type: 'PF',
  payment_type: 'pix',
  cpf: '',
  cnpj: '',
  creci: '',
  bank_id: '',
  bank_name: '',
  branch: '',
  account_number: '',
  pix_key_type: '',
  pix_key: '',
});

export const emptyInstallment = amount => ({
  amount: moneyInput(amount),
  payment_trigger: '',
  expected_on: '',
  payers: [{ user_id: '', name: '', amount: moneyInput(amount) }],
});

export const sourceOptionistOptions = source =>
  (Array.isArray(source) ? source : []).filter(Boolean).map((option, index) => {
    const externalId =
      option.id || `${option.nome || option.name}:${index + 1}`;
    const id = `midas:${externalId}`;
    const name = option.nome || option.name || '';
    return {
      id,
      external_user_id: option.id || '',
      name,
      label: name,
    };
  });

const groupDefaults = () => ({
  enabled: true,
  total_percentage: '',
  report_type: '',
  rows: [],
});

export const commissionFormFromTransaction = transaction => {
  const saved = transaction?.profile?.commission_registration || {};
  const sourceOptionists = Array.isArray(transaction?.profile?.opcionistas)
    ? transaction.profile.opcionistas
    : [];
  const net = moneyCents(
    saved.net_amount || transaction?.profile?.valor_comissao_liquida
  );
  const participants = COMMISSION_GROUPS.reduce((groups, { key }) => {
    const group = saved.participants?.[key] || {};
    groups[key] = {
      ...groupDefaults(),
      ...group,
      rows: Array.isArray(group.rows)
        ? group.rows.map(row => ({ ...emptyParticipant(), ...row }))
        : [],
    };
    return groups;
  }, {});
  const installments =
    Array.isArray(saved.installments) && saved.installments.length
      ? saved.installments.map(row => ({ ...emptyInstallment(net), ...row }))
      : [];

  return {
    gross_amount:
      saved.gross_amount || transaction?.profile?.valor_comissao_total || '',
    deduction: saved.deduction || transaction?.profile?.deducao || '',
    net_amount:
      saved.net_amount || transaction?.profile?.valor_comissao_liquida || '',
    payment_method: saved.payment_method || '',
    notes: saved.notes || '',
    modality: saved.modality || 'integral',
    installments,
    participants,
    source_optionists: sourceOptionists,
  };
};

export const recalculateNet = form => ({
  ...form,
  net_amount: moneyInput(
    Math.max(moneyCents(form.gross_amount) - moneyCents(form.deduction), 0)
  ),
});

export const splitInstallments = (form, count) => {
  const size = Math.max(1, Math.min(24, Number(count) || 1));
  const total = moneyCents(form.net_amount);
  const amounts = distributedCents(total, size);
  return {
    ...form,
    modality: size === 1 ? 'integral' : 'partes',
    installments: amounts.map((amount, index) => {
      return {
        ...emptyInstallment(amount),
        payment_trigger: form.installments[index]?.payment_trigger || '',
      };
    }),
  };
};

export const participantAmount = (netCents, totalPercentage, percentage) =>
  moneyInput(
    (netCents * Number(totalPercentage || 0) * Number(percentage || 0)) / 10000
  );

export const payloadFromCommissionForm = form => {
  const { source_optionists, ...registration } = form;
  return {
    commission_registration: {
      ...registration,
      participants: COMMISSION_GROUPS.reduce((groups, { key }) => {
        groups[key] = form.participants[key];
        return groups;
      }, {}),
    },
  };
};
